import { cn } from "@/lib/utils"

// circle-flags ships one purpose-built circular SVG per ISO country code at
// flags/{code}.svg — glob-imported so a new Region entry (e.g. Uruguay) needs
// no code change here, only a new regions.ts entry (FR-007/SC-005).
const flagModules = import.meta.glob<string>("/node_modules/circle-flags/flags/*.svg", {
  eager: true,
  query: "?url",
  import: "default",
})

const flagsByCode: Record<string, string> = Object.fromEntries(
  Object.entries(flagModules).map(([path, url]) => {
    const code = path.split("/").pop()!.replace(".svg", "")
    return [code, url]
  })
)

interface CircularFlagProps {
  /** ISO country code, lowercase, e.g. 'us'. */
  regionCode: string
  className?: string
}

export function CircularFlag({ regionCode, className }: CircularFlagProps) {
  const src = flagsByCode[regionCode.toLowerCase()]

  if (!src) return null

  return (
    <img
      src={src}
      alt=""
      aria-hidden="true"
      className={cn("h-5 w-5 rounded-full object-cover", className)}
    />
  )
}
